/**
 * Paginação do lado do cliente, com o tamanho da página escolhível.
 *
 * **`defaultPageSize`, e nunca `pageSize`** - é a única razão de este arquivo
 * existir. Passar `pageSize` torna a propriedade **controlada**: o seletor de
 * tamanho muda o estado interno do componente, e a propriedade o sobrescreve na
 * renderização seguinte. O controle aparece na tela e não obedece a ninguém, sem
 * erro no console e sem nada quebrar - o tipo de defeito que só se descobre
 * clicando.
 *
 * **Vale para lista que chega inteira do servidor**, que é quando quem pagina é
 * o navegador e mudar o tamanho não custa requisição. Na paginação por servidor
 * o tamanho vira parâmetro da consulta e mora na URL (`?porPagina=`), junto da
 * página - é o que fazem Questões, a Lei e Pessoas -, e cada tela oferece só os
 * tamanhos que a rota aceita. Onde a tela não oferece a escolha (Provas,
 * Reportes), o seletor fica desligado (`showSizeChanger: false`): mostrá-lo
 * prometeria o que a consulta não faz.
 */
export const paginacao = (padrao: number) => ({
  defaultPageSize: padrao,
  hideOnSinglePage: true,
  showSizeChanger: true,
  pageSizeOptions: [10, 20, 50, 100],
  showTotal: (total: number) => `${total} no total`,
});
